import {RichText, useBlockProps} from '@wordpress/block-editor';
import generateDynamicStyle from "./style";

const Save = ({ attributes }) => {

	let linkTarget = ( 'external' === attributes.buttonLinkTarget ) ? '_blank' : '_self',
		showIconOnHover = ( attributes.showIconOnHover ) ? ' show-on-hover' : '',
		buttonIconPosition = ( attributes.buttonIconPosition ) ? attributes.buttonIconPosition : ' icon-after';


	const ID = attributes.ID;
	return (
		<>
			<style>{ generateDynamicStyle( { attributes } ) }</style>

			<div {...useBlockProps.save( { className: attributes.className } ) } id={`block-${ID}`}>
				<div className="wpmozo-bna-pricing-table">
					<div className="wpmozo-bna-pricing-table-wrapper">
						<div className="wpmozo-bna-pricing-table-header-graphic">
							{'icon' === attributes.headerGraphics && (
								<div className="wpmozo-bna-pricing-table-header-graphic-inner">
									<i className={attributes.headerIcon}></i>
								</div>
							)}
							{'image' === attributes.headerGraphics && (
								<div
									className="wpmozo-bna-pricing-table-header-graphic-inner wpmozo-bna-header-image-container">
									<img src={attributes.headerImage} className="wpmozo-bna-header-image"/>
								</div>
							)}
						</div>
						<div className="wpmozo-bna-pricing-table-heading">
							{ '' != attributes.title && (
								<RichText.Content
									className="wpmozo-bna-pricing-table-title"
									tagName={attributes.titleLeval}
									value={attributes.title}
								/>
							)}
							{ '' != attributes.subtitle && (
								<RichText.Content
									className="wpmozo-bna-pricing-table-subtitle"
									tagName="span"
									value={attributes.subtitle}
								/>
							)}
							<span className="wpmozo-bna-bar-container">
								<hr className="wpmozo-bna-bar"/>
							</span>
						</div>
						<div className="wpmozo-bna-pricing-table-pricing">
							{ '' !== attributes.currencySymbol && 'custom' !== attributes.currencySymbol && (
								<span className="wpmozo-bna-pricing-table-currency-symbol">{attributes.currencySymbol} </span>
							) }
							{ 'custom' === attributes.currencySymbol && (
								<span className="wpmozo-bna-pricing-table-currency-symbol">{attributes.customSymbol} </span>
							) }
							{ '' !== attributes.price && (
								<span className="wpmozo-bna-pricing-table-price">{ parseFloat( attributes.price ) }</span>
							) }
							{ '' !== attributes.period && (
								<>
									<span className="wpmozo-bna-period-slash"> / </span>
									<span className="wpmozo-bna-pricing-table-period"> {attributes.period} </span>
								</>
							) }
						</div>
						<dl className="wpmozo-bna-pricing-table-features">
							{ attributes.features && attributes.features.length > 0 && attributes.features.map( (feature, index) => (
								<div key={`feature-${index}`}>
									<dt className="wpmozo-bna-pricing-table-features-list">
										{true === attributes.showFeaturesIcon && (
											<span className="wpmozo-bna-pricing-table-feature-icon">
												<i className={feature.icon}></i>
											</span>
										)}
										<span className="wpmozo-bna-pricing-table-feature-text">
											{feature.list}
										</span>
									</dt>
								</div>
							))}
						</dl>
						{true === attributes.showButton && (
							<div className="wpmozo-bna-pricing-table-button-wrapper">
								<a href={attributes.buttonUrl}
								   className={"wpmozo-bna-button " + buttonIconPosition + showIconOnHover}
								   target={linkTarget}
								>
									<span className="button_text">
										<RichText.Content value={attributes.buttonText} />
									</span>
									{ 'none' !== attributes.buttonIconType && (
										<div className={'icon' === attributes.buttonIconType ? "wpmozo-bna-button-icon" : "wpmozo-bna-button-image"}>
											{ 'icon' === attributes.buttonIconType && (
												<i className={attributes.buttonIcon}></i>
											) }
											{ 'image' === attributes.buttonIconType && (
												<img src={attributes.buttonIconImage}/>
											) }
										</div>
									) }
								</a>
							</div>
						) }
					</div>
				</div>
			</div>
		</>
	);
}
export default Save;
